/* FEROBRILL / REVERIE 360 / SHARED SIZE DATA / 21 OCT 2026
 * Load after the complete fb-measurements.js snapshot and BEFORE the existing
 * fb-product-refinements.js renderer. Never replace the full base registry.
 */
(function () {
  'use strict';
  var id = 'reserve-360-reverie-pullover';
  var source = document.getElementById('fb-reverie-measurement-data');
  if (!source) return;

  try {
    var record = JSON.parse(source.textContent || '');
    var expectedSizes = ['S', 'M', 'L', 'XL', '2XL'];
    var expectedMetrics = ['CHEST', 'LENGTH', 'SHOULDER', 'SLEEVE'];
    var valid = record.id === id && record.pending === false &&
      JSON.stringify(record.sizes) === JSON.stringify(expectedSizes) &&
      JSON.stringify(record.metrics) === JSON.stringify(expectedMetrics) &&
      Array.isArray(record.cm) && record.cm.length === 5 &&
      record.cm.every(function (row) {
        return Array.isArray(row) && row.length === 4 && row.every(function (n) {
          return typeof n === 'number' && Number.isFinite(n) && n > 0;
        });
      });
    if (!valid) throw new Error('Invalid Reverie measurement record.');

    var registry = window.FerobrillMeasurements;
    if (!registry || typeof registry !== 'object') {
      throw new Error('Base measurement registry must load before Reverie data.');
    }
    registry[id] = Object.assign({}, registry[id] || {}, record);
    window.FerobrillReverieSizeGuideStatus = {
      guideId: id,
      source: 'Manufacturer measurements supplied by FEROBRILL, 2026-10-21',
      sizes: record.sizes.slice(),
      numericMeasurementCells: 20,
      pending: false,
      loaded: true
    };
    // FerobrillInlineChartDataStatus describes the earlier static snapshot.
    // Preserve that baseline; this record override is documented separately.
  } catch (error) {
    console.warn('[FEROBRILL REVERIE SIZE GUIDE]', error.message);
  }
}());
